<template>
  <div class="no-data">
    <img src="@/assets/images/no_data.png" class="no-data-image" alt="">
    <div class="tips">{{tips || '暂无数据'}}</div>
  </div>
</template>

<script>
export default {
  name: 'no-data',
  props: {
    tips: String,
  },
  methods: {
    
  }
};
</script>

<style scoped lang="scss">
.no-data {
  text-align: center;
  .no-data-image {
    width: 362px;
    height: 190px;
    margin: 60px auto;
  }
  .tips {
    font-size: 14px;
    color: #999999;
  }
}
</style>
